<template>
  <div class="pageRoot linkListPage collectionModule classifyResourcesPage">
    <div class="pageShell">
      <div ref="pageCardMain" class="pageShell__main">
        <div ref="scrollArea" class="pageShell__scroll">
          <div class="listWorkspace">
          <section ref="filterAnchor" class="filterCard classifyResourcesFilters">
            <classify-resources-filter-panel
              v-bind="resourcesFilterPanelProps"
              v-on="resourcesFilterPanelListeners"
            >
              <template #leading>
                <button
                  type="button"
                  class="classifyResourcesBack"
                  @click="$router.push('/collection/classify/list')"
                >
                  <i class="el-icon-arrow-left" aria-hidden="true" />
                  返回分类列表
                </button>
                <span class="zoneHeader__title">筛选条件</span>
              </template>
            </classify-resources-filter-panel>
          </section>

        <section ref="tableZone" class="tableCard tableZone">
          <div class="resourceListToolbar">
            <span class="resourceListToolbar__label">列表操作</span>
            <div class="resourceListToolbar__actions">
              <el-button
                class="actionButton actionButtonGhost"
                size="small"
                icon="el-icon-upload2"
                v-check-role
                @click="dialogVisibleUpload = true"
              >
                导入
              </el-button>
              <el-button
                class="actionButton actionButtonGhost"
                size="small"
                icon="el-icon-download"
                @click="printOut"
              >
                导出
              </el-button>
              <el-button
                class="actionButton actionButtonOutline"
                size="small"
                icon="el-icon-plus"
                v-check-role
                @click="goPush($route.params.id, $route.query.name)"
              >
                新增
              </el-button>
              <el-button
                class="actionButton actionButtonGhost"
                size="small"
                v-check-role
                @click="deleteBatch"
              >
                批量删除
              </el-button>
              <el-button
                class="actionButton actionButtonOutline"
                size="small"
                icon="el-icon-document-copy"
                v-check-role
                :loading="copyResourcesLoading"
                @click="copySelectedResources"
              >
                转为独享（已选）
              </el-button>
              <el-button
                class="actionButton actionButtonOutline"
                size="small"
                icon="el-icon-document-copy"
                v-check-role
                :loading="copyResourcesLoading"
                @click="copyAllResources"
              >
                全部转为独享
              </el-button>
            </div>
          </div>
          <div class="scrollControlBar">
            <div class="scrollControlBar__lead">
              <span class="scrollControlBar__label">共</span>
              <strong class="scrollControlBar__count">{{ listTotalCount }}</strong>
              <span class="scrollControlBar__label">条</span>
              <span v-if="multipleSelection.length" class="scrollControlBar__selected">
                · 已选 {{ multipleSelection.length }}
              </span>
            </div>
            <div class="scrollControlBar__stage scrollControlBar__stage--full">
              <span class="scrollControlBar__scopeEmpty">选择筛选项即刷新，名称按回车查询</span>
            </div>
            <div class="scrollControlBar__page">
              <template v-if="listTotalCount > 0">
                <span>第 {{ listRangeStart }}–{{ listRangeEnd }} 条</span>
                <span class="scrollControlBar__metaSep" aria-hidden="true">·</span>
                <span>第 {{ currentPage }} / {{ totalPages }} 页</span>
              </template>
              <template v-else>
                <span class="scrollControlBar__emptyHint">暂无数据</span>
              </template>
            </div>
          </div>
      <!-- main -->
          <div class="tableSection" v-if="!loading">
        <el-table
          ref="multipleTable"
          class="linkTable linkTable--hybrid"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :row-key="getRowKey"
          :row-class-name="getRowClassName"
          @row-click="handleRowClick"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            :width="tableColWidth.selection"
            align="center"
            header-align="center"
            :reserve-selection="true"
          />
          <el-table-column
            label="资源名称"
            prop="wallpaperName"
            align="center"
            header-align="center"
            :width="tableColWidth.name"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                class="nameCell"
                :class="{ 'nameCell--emoji': scope.row.wallpaperType == 'emoji' }"
              >
                {{ scope.row.wallpaperName }}
              </span>
            </template>
          </el-table-column>
          <template v-if="this.$route.query.type == 'Widget'">
            <el-table-column
              prop="thumbUrl"
              label="IOS"
              align="center"
              header-align="center"
              :width="tableColWidth.previewIos"
            >
              <template slot-scope="scope">
                <template
                  v-if="
                    scope.row.wallpaperType == 'text inline' ||
                    scope.row.wallpaperType == '锁屏矩形-格言'
                  "
                >
                  <el-tooltip placement="top">
                    <div
                      slot="content"
                      style="
                        max-height: 350px;
                        overflow-y: auto;
                        text-align: center;
                      "
                    >
                      <div
                        class="contentItem"
                        v-for="(item, index) in scope.row.wallpaperUrlList[0]
                          .widgetContent.widgetConfigs[0].text"
                        :key="index"
                      >
                        {{ item.textContent }}
                      </div>
                    </div>
                    <div class="joinResourceContainer">
                      <div
                        class="contentItem"
                        v-for="(item, index) in scope.row.wallpaperUrlList[0]
                          .widgetContent.widgetConfigs[0].text"
                        :key="index"
                      >
                        {{ item.textContent }}
                      </div>
                    </div>
                  </el-tooltip>
                </template>
                <template v-else>
                  <img
                    v-lazy="scope.row.thumbUrl"
                    alt="icon"
                    class="tableIcon"
                  />
                  <div>{{ scope.row.wallpaperType }}</div>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="thumbUrlAndroid"
              label="Android"
              align="center"
              header-align="center"
              :width="tableColWidth.previewAndroid"
            >
              <template slot-scope="scope">
                <img
                  v-lazy="scope.row.thumbUrlAndroid"
                  alt="icon1"
                  class="tableIcon"
                />
                <div>{{ scope.row.wallpaperTypeAndroid }}</div>
              </template>
            </el-table-column>
          </template>
          <template
            v-else-if="
              this.$route.query.type == 'Icon' ||
              this.$route.query.type == '资源套装'
            "
          >
            <el-table-column
              prop="thumbUrl"
              label="IOS"
              align="center"
              header-align="center"
              :width="tableColWidth.previewIos"
            >
              <template slot-scope="scope">
                <img v-lazy="scope.row.thumbUrl" alt="icon" class="tableIcon" />
              </template>
            </el-table-column>
            <el-table-column
              prop="thumbUrlAndroid"
              label="Android"
              align="center"
              header-align="center"
              :width="tableColWidth.previewAndroid"
            >
              <template slot-scope="scope">
                <img
                  v-lazy="scope.row.thumbUrlAndroid"
                  alt="icon1"
                  class="tableIcon"
                />
              </template>
            </el-table-column>
          </template>
          <template v-else-if="this.$route.query.type == 'kaoMoji'">
            <el-table-column
              prop="thumb.feedDisplayContent"
              label="内容预览"
              align="center"
              header-align="center"
              :width="tableColWidth.contentPreview"
            >
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div
                    slot="content"
                    style="
                      max-height: 350px;
                      overflow-y: auto;
                      text-align: center;
                    "
                  >
                    <div class="contentItem">
                      {{ scope.row.thumb.feedDisplayContent }}
                    </div>
                  </div>
                  <div class="joinResourceContainer">
                    <div class="contentItem">
                      {{ scope.row.thumb.feedDisplayContent }}
                    </div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="wallpaperType"
              label="资源类型"
              align="center"
              header-align="center"
              :width="tableColWidth.type"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="typeTag typeTag--neutral">
                  {{ typeFilter(scope.row.wallpaperType) }}
                </span>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
              label="预览图"
              align="center"
              header-align="center"
              :width="tableColWidth.preview"
            >
              <template slot-scope="scope">
                <div class="previewCell">
                  <el-image
                    v-if="scope.row.thumbUrl"
                    class="previewCell__img"
                    :src="scope.row.thumbUrl"
                    :preview-src-list="[scope.row.thumbUrl]"
                    fit="cover"
                  >
                    <div slot="error" class="previewCell__slot previewCell__slot--error">
                      <i class="el-icon-picture-outline" />
                    </div>
                  </el-image>
                  <div v-else class="previewCell__empty">
                    <i class="el-icon-picture-outline" />
                    <span>无预览</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="wallpaperType"
              label="资源类型"
              align="center"
              header-align="center"
              :width="tableColWidth.type"
            >
              <template slot-scope="scope">
                <div class="typeCell">
                  <span class="typeTag typeTag--neutral" :title="formatResourceType(scope.row)">
                    {{ formatResourceType(scope.row) }}
                  </span>
                  <span
                    v-if="stickerKindLabel(scope.row.stickerKind)"
                    class="typeCell__kind"
                  >{{ stickerKindLabel(scope.row.stickerKind) }}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            prop="priority"
            label="优先级"
            align="center"
            header-align="center"
            :width="tableColWidth.priority"
            class-name="priorityColumn"
          >
            <template slot-scope="scope">
              <div class="priorityStepperWrap">
                <div class="priorityStepper">
                  <button
                    type="button"
                    class="priorityStepper__btn priorityStepper__btn--dec"
                    :disabled="$route.meta.role !== 2 || parsePriorityValue(scope.row.priority) <= 0"
                    aria-label="降低优先级"
                    @click="adjustPriority(scope.row, -1)"
                  >
                    −
                  </button>
                  <input
                    class="priorityStepper__input"
                    type="text"
                    inputmode="numeric"
                    :value="displayPriority(scope.row.priority)"
                    :disabled="$route.meta.role !== 2"
                    aria-label="优先级"
                    @focus="onPriorityInputFocus(scope.row)"
                    @keydown.enter.prevent="commitPriorityInput(scope.row, $event)"
                    @blur="commitPriorityInput(scope.row, $event)"
                  />
                  <button
                    type="button"
                    class="priorityStepper__btn priorityStepper__btn--inc"
                    :disabled="$route.meta.role !== 2"
                    aria-label="提高优先级"
                    @click="adjustPriority(scope.row, 1)"
                  >
                    +
                  </button>
                </div>
                <button
                  type="button"
                  class="priorityStepper__settings"
                  title="数据集优先级"
                  :disabled="$route.meta.role !== 2"
                  @click="showPriority(scope.row.id)"
                >
                  <i class="el-icon-setting" />
                </button>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="defaultLockGroupName"
            label="关联解锁"
            align="center"
            header-align="center"
            :width="tableColWidth.lock"
            show-overflow-tooltip
            class-name="lockColumn"
          >
            <template slot-scope="scope">
              <button
                type="button"
                class="lockCell lockCell--pill"
                @click="showLinkResource(scope.row.id)"
              >
                <span class="lockCell__iconWrap" aria-hidden="true">
                  <i class="el-icon-unlock lockCell__icon" />
                </span>
                <span class="lockCell__name">{{
                  scope.row.defaultLockGroupName || '免费解锁'
                }}</span>
              </button>
            </template>
          </el-table-column>

          <el-table-column
            v-if="dataSetId !== ''"
            prop="lockGroupName"
            label="解锁组"
            align="center"
            header-align="center"
            :width="tableColWidth.lockGroup"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.lockGroupName }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="onOrOff"
            label="状态"
            align="center"
            header-align="center"
            :width="tableColWidth.status"
          >
            <template slot-scope="scope">
              <span
                class="statusPill"
                :class="
                  scope.row.onOrOff === 1 ? 'statusPill--online' : 'statusPill--offline'
                "
              >
                <span class="statusPill__dot" aria-hidden="true" />
                {{ scope.row.onOrOff === 1 ? '上线' : '下线' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            label-class-name="linkListActionColumnHead"
            align="center"
            header-align="center"
            :width="tableColWidth.action"
            class-name="actionColumn"
          >
            <template slot="header">
              <span class="linkListActionColumnHead__label">操作</span>
            </template>
            <template slot-scope="scope">
              <div class="linkTableActionCell">
                <el-button
                  size="small"
                  class="rowActionBtn rowActionBtn--ghost"
                  icon="el-icon-edit"
                  @click.stop="goEditResource(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="$route.meta.role == 2"
                  size="small"
                  class="rowActionBtn rowActionBtn--ghost rowActionBtn--danger"
                  @click.stop="deleteResources(scope.row.id)"
                >
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
          </div>
          <div v-else class="tableSkeletonWrap">
            <el-skeleton :rows="8" animated />
          </div>
        </section>
          </div>
        </div>

        <div class="pageShell__footer tableCard__footer footerBar">
        <div class="footerSummary">
          共 <strong class="footerSummary__count">{{ listTotalCount }}</strong> 条 · 第
          {{ currentPage }} / {{ totalPages }} 页
        </div>
        <el-pagination
          class="linkPagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next,sizes,jumper"
          :total="total"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="currentPageSize"
          :current-page.sync="currentPage"
        />
        </div>
      </div>
    </div>
    <el-dialog
      title="修改优先级"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        label-position="top"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        size="mini"
        v-loading="dialogLoading"
        :disabled="$route.meta.role !== 2"
      >
        <el-form-item label="默认优先级" prop="priority">
          <el-input
            v-model="ruleForm.priority"
            placeholder="请输入优先级"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="数据集优先级(选填)" prop="dataPriority">
          <div
            class="dataList"
            v-for="(item, index) in ruleForm.dataPriority"
            :key="index"
          >
            <el-input
              v-model="item.priority"
              placeholder="请输入优先级"
              style="width: 120px; margin-right: 10px"
            ></el-input>

            <el-select
              v-model="item.dataSetId"
              placeholder="请选择数据集"
              style="width: 120px; margin-right: 10px"
            >
              <el-option
                v-for="item in dataOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>

            <div
              style="line-height: 39px; margin-right: 10px"
              v-show="ruleForm.dataPriority.length > 1"
              @click="deleteData(index)"
            >
              <i class="el-icon-error deleteIcon"></i>
            </div>
            <div
              style="line-height: 39px"
              @click="addData"
              v-show="ruleForm.dataPriority.length - 1 === index"
            >
              <i class="el-icon-circle-plus addIcon"></i>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer" v-check-role>
        <el-button @click="handleClose" size="mini">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="关联解锁组"
      :visible.sync="linkResourceVisible"
      width="30%"
      top="25vh"
      :before-close="linkResourceClose"
    >
      <div v-loading="linkResourceLoadinhg">
        <el-form
          disabled
          :model="linkResourceForm"
          label-position="top"
          size="mini"
        >
          <el-form-item label="默认解锁组">
            <el-input v-model="linkResourceForm.defaultUnlockType"></el-input>
          </el-form-item>
          <el-form-item label="数据集解锁组(选填)">
            <div
              v-for="(item, index) in linkResourceForm.data_unlock_type_list"
              :key="index"
              style="display: flex; margin-bottom: 5px"
            >
              <el-input
                v-model="item.lockGroupName"
                style="margin-right: 20px"
              ></el-input>
              <el-input v-model="item.dataSetName"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="linkResourceClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="linkResourceClose()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisibleUpload"
      width="30%"
      :before-close="handleUploadClose"
    >
      <div>
        <div style="display: flex">
          <div>上传类型：</div>
          <div>
            <el-radio v-model="radio" label="1">覆盖</el-radio>
            <el-radio v-model="radio" label="2">新增</el-radio>
          </div>
        </div>
        <div>
          <el-upload
            class="upload-drag"
            drag
            action="/"
            :http-request="excelRequest"
            :show-file-list="false"
          >
            <div v-if="fileName === ''">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </div>
            <div v-else>
              <div style="margin-top: 70px">
                <h2 style="color: #579ef8">{{ fileName }}</h2>
              </div>
            </div>
          </el-upload>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleUploadClose()">取 消</el-button>
        <el-button size="small" type="primary" @click="submitExcel()"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listWallpaperById,
  deleteWallpaperByIds,
  updatePriority,
  queryPriorityAndDataSet,
  uploadExcel,
  copyCategoryResources,
} from "../../../api/classifyManage";
import { getLockGroupList } from "../../../api/unlockGroup";
import { getAllDataList, getQueryNameById } from "../../../api/comment";
import { mutations } from "../../../utils/store";
import { listAllWallpaperType as listMusicWallpaperType } from "../../../api/genericResource";
import ClassifyResourcesFilterPanel from "./ClassifyResourcesFilterPanel.vue";
import linkListScrollControlMixin from "../../resourceManage/genericResourceManage/linkListScrollControlMixin";
import { computeClassifyResourcesColumnWidths } from "./classifyResourcesTableLayout";
import { buildLocationWithBackTo } from "../../../utils/layoutNavigation";
import {
  stickerKindLabel,
  toExportWallpaperType,
  toTypeQuery,
} from "../../resourceManage/genericResourceManage/resourceTypeFilter";
export default {
  name: "resources",
  components: {
    ClassifyResourcesFilterPanel,
  },
  mixins: [linkListScrollControlMixin],
  data() {
    return {
      name: "",
      wallpaperType: "",
      typeOptions: [],
      tableData: [],
      currentPage: 1,
      currentPageSize: 25,
      total: 0,
      loading: false,
      multipleSelection: [],
      copyResourcesLoading: false,
      dialogVisible: false,
      ruleForm: {
        priority: "",
        dataPriority: [{ priority: "", dataSetId: "" }],
        wallpaperId: "",
      },
      rules: {
        priority: [
          { required: true, message: "数据优先级不能为空", trigger: "blur" },
        ],
      },
      linkResourceRules: {
        linkResource: [
          { required: true, message: "关联解锁不能为空", trigger: "change" },
        ],
      },
      dialogLoading: false,
      dataOptions: [],
      priorityOptions: [],
      flag: false,
      oldPriority: "",
      radio: "1",
      dialogVisibleUpload: false,
      excelFile: "",
      fileName: "",
      linkResourceVisible: false,
      linkResourceForm: {},
      linkResourceOptions: [],
      linkResourceLoadinhg: false,
      isSyncingTableSelection: false,
      AndroidType: "",
      wallpaperStatus: "",
      wallpaperStatusOptions: [
        { label: "上线", value: "1" },
        { label: "下线", value: "0" },
        { label: "资源处理中", value: "10" },
        { label: "资源处理失败", value: "11" },
      ],
      dataSetId: "",
      dataSetIds: [],
    };
  },
  computed: {
    listTotalCount() {
      const parsed = Number(this.total);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    totalPages() {
      if (this.listTotalCount === 0) {
        return 1;
      }
      return Math.max(1, Math.ceil(this.listTotalCount / this.currentPageSize));
    },
    listRangeStart() {
      if (this.listTotalCount === 0) {
        return 0;
      }
      return (this.currentPage - 1) * this.currentPageSize + 1;
    },
    listRangeEnd() {
      if (this.listTotalCount === 0) {
        return 0;
      }
      return Math.min(
        this.currentPage * this.currentPageSize,
        this.listTotalCount
      );
    },
    resourcesFilterProfile() {
      return this.$route.query.type === "Widget" ? "widget" : "default";
    },
    resourcesTableProfile() {
      const type = this.$route.query.type;
      if (type === "Widget") {
        return "widget";
      }
      if (type === "Icon" || type === "资源套装") {
        return "icon";
      }
      if (type === "kaoMoji") {
        return "kaomoji";
      }
      return "default";
    },
    tableColWidth() {
      return computeClassifyResourcesColumnWidths(this.tableContainerWidth, {
        profile: this.resourcesTableProfile,
        showLockGroup: this.dataSetId !== "",
        showAction: this.$route.meta.role == 2,
      });
    },
    isHighlightType() {
      return this.$route.query.type === "high_light";
    },
    /** 与 created 里拉类型列表的判断一致：通用资源分类的类型来自接口，需要分组和排序。 */
    isGenericCategory() {
      const type = this.$route.query.type;
      return type == 21 || type === "通用";
    },
    resourcesFilterPanelProps() {
      return {
        profile: this.resourcesFilterProfile,
        isHighlightType: this.isHighlightType,
        name: this.name,
        wallpaperType: this.wallpaperType,
        sortTypeOptions: this.isGenericCategory,
        androidType: this.AndroidType,
        wallpaperStatus: this.wallpaperStatus,
        dataSetId: this.dataSetId,
        dataSetIds: this.dataSetIds,
        typeOptions: this.typeOptions,
        androidTypeOptions: this.AndroidTypeOptions,
        dataOptions: this.dataOptions,
        wallpaperStatusOptions: this.wallpaperStatusOptions,
      };
    },
    resourcesFilterPanelListeners() {
      return {
        search: this.search,
        reset: this.resetResourceFilters,
        "update:name": (value) => {
          this.name = value;
        },
        "update:wallpaperType": (value) => {
          this.wallpaperType = value;
        },
        "update:androidType": (value) => {
          this.AndroidType = value;
        },
        "update:wallpaperStatus": (value) => {
          this.wallpaperStatus = value;
        },
        "update:dataSetId": (value) => {
          this.dataSetId = value;
        },
        "update:dataSetIds": (value) => {
          this.dataSetIds = value;
        },
      };
    },
    typeFilter: function () {
      return function (value) {
        if (value == "") {
          return "";
        }
        let option = new Map();
        option.set("1", "KAOMOJI");
        option.set("2", "TEXT ART");
        option.set("3", "QUOTES");
        option.set("4", "GREETINGS");
        option.set("5", "TEMPLATE");
        option.set("KAOMOJI", "1");
        option.set("TEXT ART", "2");
        option.set("QUOTES", "3");
        option.set("GREETINGS", 4);
        option.set("TEMPLATE", 5);
        option.set("背景资源", "1");
        option.set("按键资源", "2");
        option.set("字体资源", "3");
        option.set("动效资源", "4");
        option.set("音效资源", "5");
        return option.get(value);
      };
    },
    diyTypeFilter: function () {
      return function (value) {
        if (value == "") {
          return "";
        }
        let option = new Map();
        option.set("1", "背景资源");
        option.set("2", "按键资源");
        option.set("3", "字体资源");
        option.set("4", "动效资源");
        option.set("5", "音效资源");
        return option.get(value);
      };
    },
    highLightTypeFilter: function () {
      return function (value) {
        if (value == "") {
          return "";
        }
        let option = new Map();
        option.set("14", "highlight 资源");
        option.set("1", "bar sticker - 小");
        option.set("2", "bar sticker - 大");
        option.set("3", "charging icon");
        return option.get(value);
      };
    },
  },
  created() {
    this.bindLinkListScrollControl();
    let type = this.$route.query.type;
    // 分类关联仅壁纸、AI 角色、通用资源；通用资源类型从后端动态拉取。
    // categoryType 可能是 ID（1/17/21）或历史字符串名称，需同时兼容
    if (type == 21 || type === "通用") {
      // 动态从后端获取通用资源类型
      listMusicWallpaperType().then(res => {
        if (res.success && res.data) {
          this.typeOptions = res.data;
        }
      });
    } else if (type == 17 || type === "ai_assistant") {
      this.typeOptions = ["ai_assistant"];
    } else {
      this.typeOptions = [
        "静态壁纸资源",
        "视频壁纸资源",
        "4D Parallax壁纸资源",
        "重力壁纸资源",
        "动画壁纸资源",
        "交互壁纸资源",
        "壁纸合集资源",
        "桌面宠物",
        "毛玻璃",
        "时钟壁纸",
        "3d重力",
        "联系人海报资源",
        "游戏壁纸资源",
        "来电秀壁纸资源",
        "实况壁纸资源",
        "unity壁纸",
        "TV屏保",
        "live壁纸",
        "OS26景深壁纸资源",
        "flip",
        "AIGC",
      ];
    }
    this.setBreadTitle(this.$route.query.name + "-列表");
    this.getList();
    this.getAllDataSet();
    this.getAllLinkResource();
  },
  mounted() {
    this.setBreadTitle(this.$route.query.name + "-列表");
  },
  watch: {
    tableContainerWidth() {
      this.scheduleTableLayout();
    },
    loading(value) {
      if (!value) {
        this.onLinkListDataRendered();
      } else {
        this.$nextTick(() => {
          this.measureTableZoneWidth();
        });
      }
    },
    tableData() {
      this.$nextTick(() => {
        this.scheduleTableLayout();
      });
    },
    dataSetId() {
      this.$nextTick(() => {
        this.scheduleTableLayout();
      });
    },
  },
  beforeDestroy() {
    if (!this.flag) {
      this.setBreadTitle(undefined);
    }
  },

  methods: {
    setBreadTitle: mutations.setBreadTitle,
    stickerKindLabel,
    /** 两栏筛选的选中值 → 接口的 wallpaperType / wallpaperTypes / stickerKind；highlight 的数字取值原样传。 */
    typeQueryParams() {
      const query = toTypeQuery(this.wallpaperType);
      return {
        wallpaperType: query.wallpaperType || "",
        wallpaperTypes: query.wallpaperTypes,
        stickerKind: query.stickerKind,
      };
    },
    formatResourceType(row) {
      if (this.$route.query.type == "diy") {
        return this.diyTypeFilter(row.wallpaperType);
      }
      if (this.$route.query.type == "high_light") {
        return this.highLightTypeFilter(row.wallpaperType);
      }
      return row.wallpaperType || "—";
    },
    //重新获取列表数据
    getList() {
      this.loading = true;
      listWallpaperById({
        name: this.name,
        ...this.typeQueryParams(),
        id: this.$route.params.id,
        pageNum: this.currentPage,
        pageSize: this.currentPageSize,
        wallpaperStatus: this.wallpaperStatus,
        dataSetId: this.dataSetId,
        dataSetIds: this.dataSetIds,
      })
        .then((res) => {
          if (res.success) {
            this.tableData = this.normalizeResourceRows(res.data.wallpaperVOList);
            this.total = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    normalizeResourceRows(list) {
      return (list || []).map((row) => {
        const id =
          row && row.id != null && row.id !== "" ? row.id : row && row.wallpaperId;
        return {
          ...row,
          id,
        };
      });
    },
    getRowKey(row) {
      if (!row) {
        return "";
      }
      const id = row.id != null && row.id !== "" ? row.id : row.wallpaperId;
      return id != null && id !== "" ? String(id) : "";
    },
    getRowClassName({ row }) {
      const rowKey = this.getRowKey(row);
      if (!rowKey) {
        return "";
      }
      const selected = (this.multipleSelection || []).some(
        (item) => this.getRowKey(item) === rowKey
      );
      return selected ? "linkTable__row--selected" : "";
    },
    handleRowClick(row, _column, event) {
      if (!event || !event.target) {
        return;
      }
      if (
        event.target.closest(
          "a, button, .el-button, .el-image, img, .el-checkbox, .lockCell, .priorityStepper, .priorityStepper__settings, .priorityStepper__input"
        )
      ) {
        return;
      }
      const table = this.$refs.multipleTable;
      if (table) {
        table.toggleRowSelection(row);
      }
    },
    syncTableSelectionFromStore() {
      const table = this.$refs.multipleTable;
      if (!table || !this.tableData.length) {
        return;
      }
      const selectedKeys = new Set(
        (this.multipleSelection || []).map((row) => this.getRowKey(row))
      );
      this.isSyncingTableSelection = true;
      this.tableData.forEach((row) => {
        table.toggleRowSelection(row, selectedKeys.has(this.getRowKey(row)));
      });
      this.$nextTick(() => {
        this.isSyncingTableSelection = false;
      });
    },
    //获取所有的数据集
    getAllDataSet() {
      getAllDataList().then((res) => {
        if (res.success) {
          this.dataOptions = res.data;
        }
      });
    },
    //获取所有的解锁组数据
    getAllLinkResource() {
      getLockGroupList({}, 2)
        .then((res) => {
          if (res.success) {
            this.linkResourceOptions = res.data;
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    //header-依据查询条件进行查询
    search() {
      this.currentPage = 1;
      this.getList();
    },
    resetResourceFilters() {
      this.name = "";
      this.wallpaperType = "";
      this.wallpaperStatus = "";
      this.AndroidType = "";
      this.dataSetId = "";
      this.dataSetIds = [];
      this.search();
    },
    //footer-大小改变
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.$nextTick(() => {
        this.getList();
      });
    },
    //footer-当前页数改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    //获取选择的选项（进行批量操作）
    handleSelectionChange(val) {
      if (this.isSyncingTableSelection) {
        return;
      }
      this.multipleSelection = val || [];
    },
    //删除某一项资源
    deleteResources(id) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteWallpaperByIds({
            wallpaperIds: id + "",
            categoryId: this.$route.params.id,
          }).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除资源
    deleteBatch() {
      //获取到选中的元素进行批量删除
      this.$confirm("改操作将对选中的元素进行批量删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.multipleSelection.map((e) => e.id).join(",");
          if (list) {
            deleteWallpaperByIds({
              wallpaperIds: list,
              categoryId: this.$route.params.id,
            }).then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "批量删除成功",
                });
                this.getList();
              }
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    /**
     * 已选转为独享：生成新资源实体，仅本分类换绑；列表条数不变，其它分类仍指向原资源。
     */
    copySelectedResources() {
      const ids = (this.multipleSelection || [])
        .map((row) => row.id)
        .filter((id) => id != null);
      if (!ids.length) {
        this.$message.warning("请先勾选要转为独享的资源");
        return;
      }
      this.$confirm(
        `将为已选的 ${ids.length} 条各生成一份新资源，并只把本分类改挂到新资源上（对应行换成新资源，不会多出一行）。其它分类继续使用原资源。新资源默认下线。是否继续？`,
        "转为独享资源",
        {
          confirmButtonText: "确定转为独享",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => this.runCopyCategoryResources(ids))
        .catch(() => {});
    },
    /**
     * 本分类全部转为独享（含当前页以外的全部关联；不受列表筛选影响）。
     */
    copyAllResources() {
      const filteredTotal = this.listTotalCount || 0;
      const hasFilter = this.hasActiveClassifyResourceFilters();
      if (!hasFilter && filteredTotal <= 0) {
        this.$message.warning("当前分类没有可转为独享的资源");
        return;
      }
      const message = hasFilter
        ? `当前有筛选，列表显示 ${filteredTotal} 条，但仍会对本分类下全部挂靠资源转为独享（不受筛选限制）。会各生成新资源并只把本分类改挂上去（条数不会变多）。其它分类继续用原资源。新资源默认下线。是否继续？`
        : `将对本分类当前挂靠的 ${filteredTotal} 条资源各生成一份新资源，并只把本分类改挂到新资源上（列表仍是 ${filteredTotal} 条，不会变多）。其它分类继续使用原资源。新资源默认下线。是否继续？`;
      this.$confirm(message, "转为独享资源", {
        confirmButtonText: "确定转为独享",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => this.runCopyCategoryResources(null))
        .catch(() => {});
    },
    /** 名称 / 类型 / 状态 / 数据集任一筛选即视为有筛选（与 getList 入参对齐）。 */
    hasActiveClassifyResourceFilters() {
      const hasDataSetIds =
        Array.isArray(this.dataSetIds) && this.dataSetIds.length > 0;
      return Boolean(
        (this.name && String(this.name).trim()) ||
          (this.wallpaperType && String(this.wallpaperType).trim()) ||
          (this.wallpaperStatus !== "" &&
            this.wallpaperStatus != null &&
            this.wallpaperStatus !== undefined) ||
          (this.dataSetId !== "" && this.dataSetId != null) ||
          hasDataSetIds
      );
    },
    runCopyCategoryResources(wallpaperIds) {
      this.copyResourcesLoading = true;
      return copyCategoryResources({
        categoryId: Number(this.$route.params.id),
        wallpaperIds: wallpaperIds || undefined,
      })
        .then((res) => {
          if (res && res.success) {
            const count =
              res.data && res.data.copiedCount != null
                ? res.data.copiedCount
                : wallpaperIds
                ? wallpaperIds.length
                : "";
            this.$message({
              type: "success",
              message:
                count !== ""
                  ? `已将 ${count} 条资源转为独享`
                  : "转为独享成功",
            });
            this.getList();
            return;
          }
          this.$message.error(
            (res && (res.errMessage || res.message)) || "转为独享失败"
          );
        })
        .catch(() => {
          this.$message.error("转为独享失败，请稍后重试");
        })
        .finally(() => {
          this.copyResourcesLoading = false;
        });
    },
    //点。。。
    showPriority(id) {
      this.dialogVisible = true;
      this.dialogLoading = true;
      queryPriorityAndDataSet({
        wallpaperId: id,
        categoryId: this.$route.params.id,
      })
        .then((res) => {
          if (res.success) {
            this.ruleForm.wallpaperId = id;
            this.ruleForm.priority = res.data.priority;
            var dataPriority = res.data.dataSets;
            if (JSON.stringify(dataPriority) !== "[]") {
              this.ruleForm.dataPriority = res.data.dataSets;
            }
          }
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    /**
     * 分类关联解锁弹窗按分类类型解析资源 API 前缀。
     * 按分类 type 解析资源查询接口名（壁纸 / aiAssistant / music）。
     */
    resolveCategoryResourceQueryName(categoryType) {
      if (categoryType == 17 || categoryType === "ai_assistant") {
        return "aiAssistant";
      }
      if (categoryType == 21 || categoryType === "通用") {
        return "music";
      }
      return "wallpaper";
    },
    showLinkResource(id) {
      this.linkResourceVisible = true;
      this.linkResourceLoadinhg = true;
      const queryName = this.resolveCategoryResourceQueryName(
        this.$route.query.type
      );

      getQueryNameById({ id, queryName })
        .then((res) => {
          if (res.success) {
            this.linkResourceForm.defaultUnlockType =
              res.data.defaultLockGroupName;
            this.linkResourceForm.data_unlock_type_list =
              res.data.wallpaperLockGroupVOList;
          }
        })
        .finally(() => {
          this.linkResourceLoadinhg = false;
        });
    },
    //关键dialoag
    handleClose() {
      this.$refs["ruleForm"].clearValidate();
      this.dialogVisible = false;
      this.ruleForm = {
        priority: "",
        dataPriority: [{ priority: "", dataSetId: "" }],
      };
    },
    linkResourceClose() {
      this.linkResourceVisible = false;
      this.linkResourceForm = {};
    },
    addData() {
      this.ruleForm.dataPriority.push({ priority: "", dataSetId: "" });
    },
    deleteData(index) {
      this.ruleForm.dataPriority.splice(index, 1);
    },
    //提交
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          var list = JSON.parse(JSON.stringify(this.ruleForm.dataPriority));
          for (let i = list.length - 1; i >= 0; i--) {
            if (list[i].dataSetId === "") {
              list.splice(i, 1);
            }
          }
          updatePriority({
            categoryId: this.$route.params.id,
            wallpaperId: this.ruleForm.wallpaperId,
            priority: this.ruleForm.priority,
            dataSets: list,
          }).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "提交成功",
              });
              this.handleClose();
              this.getList();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitLinkResourceForm() {
      this.$refs["linkResourceForm"].validate((valid) => {
        if (valid) {
          console.log("good submit~");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    goPush(id, name) {
      this.flag = true;
      const query = { name };
      if (this.$route.query.type) {
        query.type = this.$route.query.type;
      }
      this.$router.push({
        path: `/collection/classify/resourcesCreate/${id}`,
        query,
      });
      this.setBreadTitle(name + "-新增");
    },
    setOldPriority(val) {
      this.oldPriority = val;
    },
    parsePriorityValue(val) {
      const parsed = Number(val);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    displayPriority(val) {
      return this.parsePriorityValue(val);
    },
    onPriorityInputFocus(row) {
      this.oldPriority = row.priority;
    },
    /** 中间输入框提交：仅接受非负整数，非法则回显并提示。 */
    commitPriorityInput(row, event) {
      if (this.$route.meta.role !== 2 || !row || !event || !event.target) {
        return;
      }
      const raw = String(event.target.value == null ? "" : event.target.value).trim();
      if (raw === "") {
        event.target.value = String(this.displayPriority(this.oldPriority));
        row.priority = this.oldPriority;
        return;
      }
      if (!/^\d+$/.test(raw)) {
        this.$message.warning("优先级须为非负整数");
        event.target.value = String(this.displayPriority(row.priority));
        return;
      }
      const next = Number(raw);
      if (next === this.parsePriorityValue(row.priority)) {
        event.target.value = String(next);
        return;
      }
      this.oldPriority = row.priority;
      row.priority = next;
      event.target.value = String(next);
      this.changePriority(row.id, next);
    },
    adjustPriority(row, delta) {
      if (this.$route.meta.role !== 2) {
        return;
      }
      const previous = row.priority;
      const next = this.parsePriorityValue(row.priority) + delta;
      if (next < 0) {
        return;
      }
      row.priority = next;
      this.oldPriority = previous;
      this.changePriority(row.id, next);
    },
    /** 按分类类型跳到对应资源编辑页，并带 backTo 回到本分类资源列表。 */
    resolveResourceEditPath(resourceId) {
      const type = this.$route.query.type;
      if (type == 21 || type === "通用") {
        return `/resource/link/edit/${resourceId}`;
      }
      if (type == 17 || type === "ai_assistant") {
        return `/resource/aiAssistant/edit/${resourceId}`;
      }
      return `/resource/wallpaper/edit/${resourceId}`;
    },
    goEditResource(row) {
      const id = row && (row.id != null && row.id !== "" ? row.id : row.wallpaperId);
      if (id == null || id === "") {
        this.$message.warning("资源 ID 缺失，无法进入编辑页");
        return;
      }
      this.$router.push(
        buildLocationWithBackTo(this.resolveResourceEditPath(id), this.$route.fullPath)
      );
    },
    changePriority(id, val) {
      if (val !== this.oldPriority && val !== "") {
        const previous = this.oldPriority;
        queryPriorityAndDataSet({
          wallpaperId: id,
          categoryId: this.$route.params.id,
        })
          .then((res) => {
            if (!res || !res.success) {
              this.rollbackPriorityRow(id, previous);
              this.$message.error("优先级修改失败");
              return;
            }
            return updatePriority({
              categoryId: this.$route.params.id,
              wallpaperId: id,
              priority: val,
              dataSets: res.data.dataSets,
            }).then((updateRes) => {
              if (updateRes && updateRes.success) {
                this.$message({
                  type: "success",
                  message: "优先级修改成功",
                });
                return;
              }
              this.rollbackPriorityRow(id, previous);
              this.$message.error("优先级修改失败");
            });
          })
          .catch(() => {
            this.rollbackPriorityRow(id, previous);
            this.$message.error("优先级修改失败，请稍后重试");
          });
      } else if (val === "") {
        queryPriorityAndDataSet({
          wallpaperId: id,
          categoryId: this.$route.params.id,
        }).then((res) => {
          if (res.success) {
            updatePriority({
              categoryId: this.$route.params.id,
              wallpaperId: id,
              priority: this.oldPriority,
              dataSets: res.data.dataSets,
            }).then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "优先级不能为空",
                });
                this.getList();
              }
            });
          }
        });
      }
    },
    /** API 失败时把表格行优先级回滚到提交前的值。 */
    rollbackPriorityRow(id, previous) {
      const row = (this.tableData || []).find((item) => item && item.id === id);
      if (row) {
        row.priority = previous;
      }
    },
    handleUploadClose() {
      this.excelFile = "";
      this.fileName = "";
      this.radio = "1";
      this.dialogVisibleUpload = false;
    },
    printOut() {
      if (this.tableData.length === 0) {
        return;
      }

      let baseURL =
        process.env.NODE_ENV === "development"
          ? "/api"
          : `${window.location.protocol}//${window.location.host}`;
      // 导出接口只认单个类型：两栏筛选选中整组或多项时不按类型筛，贴纸子类型退回全部贴纸
      const exportType = encodeURIComponent(toExportWallpaperType(this.wallpaperType));
      window.location = `${baseURL}/v1/api/category/exportResourceList?categoryId=${this.$route.params.id}&wallpaperType=${exportType}&wallpaperName=${this.name}&dataSetId=${this.dataSetId}`;
    },
    excelRequest(params) {
      var file = new FormData();
      this.fileName = params.file.name;
      file.append("file", params.file); //传文件
      this.excelFile = file;
      return false; //屏蔽了action的默认上传
    },
    //提交excel
    submitExcel() {
      uploadExcel(
        { id: this.$route.params.id, type: this.radio },
        this.excelFile
      )
        .then((res) => {
          if (res.success) {
            this.$message({ type: "success", message: "资源提交成功" });
            this.getList();
          }
        })
        .catch((err) => {
          this.$message({ type: "error", message: err });
        });
      this.handleUploadClose();
    },
  },
};
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';

.classifyResourcesBack {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 6px 12px 6px 10px;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: var(--link-radius-sm, 8px);
  background: var(--link-card-surface, #f7f4ef);
  box-shadow: var(--link-highlight-top), var(--link-shadow-soft);
  font-family: var(--link-font-family);
  font-size: var(--link-text-sm, 12px);
  font-weight: var(--link-font-semibold, 600);
  line-height: 1.2;
  color: var(--link-ink-emphasis, #44403c);
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}

.classifyResourcesBack i {
  font-size: 13px;
  font-weight: 700;
  color: var(--link-accent, #2563eb);
}

.classifyResourcesBack:hover {
  background: var(--link-accent-bg, #f0f7ff);
  border-color: var(--link-accent-border, #cce5ff);
  color: var(--link-ink, #292524);
  box-shadow: var(--link-highlight-top), 0 2px 8px rgba(37, 99, 235, 0.12);
}

.classifyResourcesBack:hover i {
  color: var(--link-accent-hover, #1d4ed8);
}

.linkListPage.classifyResourcesPage .nameCell--emoji {
  font-size: 20px;
  line-height: 1.2;
}

.resourceListToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--link-line, #eee9e2);
}

.resourceListToolbar__label {
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
}

.resourceListToolbar__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.tableIcon,
.tableIcon1 {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: none;
  background: var(--link-workspace, #f3f0ea);
}

.priorityStepperWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: 100%;
}

.priorityStepper {
  display: inline-flex;
  align-items: stretch;
  width: 96px;
  max-width: 100%;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: 8px;
  overflow: hidden;
  background: var(--link-surface, #fff);
}

.priorityStepper__btn {
  flex: 0 0 26px;
  margin: 0;
  padding: 0;
  border: none;
  background: var(--link-field-bg, #f3f0ea);
  color: var(--link-ink-secondary);
  font-size: 15px;
  line-height: 28px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.priorityStepper__btn:hover:not(:disabled) {
  background: var(--link-accent-bg, #f0f7ff);
  color: var(--link-accent);
}

.priorityStepper__btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.priorityStepper__btn--dec {
  border-right: 1px solid var(--link-line-strong, #e5dfd6);
}

.priorityStepper__btn--inc {
  border-left: 1px solid var(--link-line-strong, #e5dfd6);
}

.priorityStepper__value {
  flex: 1 1 auto;
  min-width: 28px;
  padding: 0 2px;
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-semibold);
  font-variant-numeric: tabular-nums;
  line-height: 28px;
  text-align: center;
  color: var(--link-ink);
  background: var(--link-surface, #fff);
}

.priorityStepper__input {
  box-sizing: border-box;
  flex: 1 1 auto;
  width: 44px;
  min-width: 40px;
  height: 28px;
  margin: 0;
  padding: 0 4px;
  border: 0;
  border-radius: 0;
  background: var(--link-surface, #fff);
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-semibold);
  font-variant-numeric: tabular-nums;
  line-height: 28px;
  text-align: center;
  color: var(--link-ink);
  outline: none;
}

.priorityStepper__input:focus:not(:disabled) {
  background: #fff;
  box-shadow: inset 0 0 0 1px var(--link-accent, #a67c52);
}

.priorityStepper__input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.priorityStepper__settings {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: 6px;
  background: var(--link-surface, #fff);
  color: var(--link-ink-secondary);
  cursor: pointer;
}

.priorityStepper__settings:hover:not(:disabled) {
  border-color: var(--link-accent);
  color: var(--link-accent);
}

.priorityStepper__settings:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.rowActionBtn--danger {
  color: #b91c1c !important;
}

.rowActionBtn--danger:hover {
  background: #fee2e2 !important;
}

::v-deep .el-pagination__jump {
  margin-left: -5px;
}
</style>



<style scoped>
.dataList {
  display: flex;
  align-items: center;
}

.addIcon {
  font-size: 20px;
  color: var(--link-accent);
  cursor: pointer;
}

.deleteIcon {
  font-size: 20px;
  color: #b91c1c;
  cursor: pointer;
}

.joinResourceContainer {
  height: 50px;
  overflow-x: auto;
  overflow-y: auto;
}

.contentItem {
  margin-bottom: 10px;
  white-space: pre;
}

.upload-drag {
  margin-top: 50px;
  text-align: center;
}

::v-deep .el-input-group__append,
::v-deep .el-input-group__prepend {
  background-color: var(--link-accent);
  color: #ffffff;
  border: 1px solid var(--link-accent);
}

::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep .el-input.is-disabled .el-input__inner {
  height: 28px;
  padding-left: 10px;
}
</style>
